<template>
  <div class="card u-pd-0">
    <ul class="listGroup row">
      <li class="listGroup__item"
        v-for="item in collection"
        :key="item.items_id"
        @click="showDetail(item)"
        >
        <div class="media">
          <div class="media__image">
            <uranai-img data-clip-path-support="true" data-size="sm" size="sm" :src="item.image_url"></uranai-img>
          </div>
          <div class="media__content">
            <p class="counselorName">{{ item.name }}</p>
            <p class="divinationMethod">{{ item.divination_name }}</p>
            <p class="price cp-halfprice__buyPage">
              <span v-price="item.price_taxin"></span>（税込）
              <strong>50%OFF</strong>
            </p>
          </div>
          <div class="media__sub">
            <div v-if="isArrival(item)" class="orderLimit" :data-arrival="true">
              <small>残り{{ getRemaining(item) }}人</small>受付中
            </div>
            <div v-else class="orderLimit" :data-arrival="false">
              休止中
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
const axiosInstance = axios.create()

export default {
  props: {
     status: String
  },
  name: 'firstcome-showcase-halfprice',
  data() {
    return {
      url: '/api/firstcome',
      collection: []
    }
  },
  created() {
    axiosInstance.get(this.url, { params: {status: this.status} }).then(res => {
      if (res.status === 200 && res.data.response === 'OK') {
        this.collection = res.data.data
      } else {
        throw new Error(res.data.description)
      }
    })
  },
  methods: {
    showDetail(item) {
      this.$emit('call-detail', item.items_id)
    },
    getRemaining(item) {
      return item.max_order - item.orders_count || 0
    },
    isArrival(item) {
      return this.getRemaining(item) > 0 && item.is_arrival
    }
  }
}</script>

<style lang="scss">

p.price.cp-halfprice__buyPage {
    color: #FF0000;
}

.cp-halfprice__buyPage.price strong {
    background: #FF0000;
    color: #FFF;
    font-size: 10px;
    border-radius: 3px;
    padding: 1px 4px;
}


.card {

}
.listGroup {
  margin: 0;
  &__item {
    padding: 12px 16px !important;
    cursor: pointer;
  }
  > &__item:last-child {
    border-bottom: 0;
  }
}

.media {
  align-items: center;
  p {
    line-height: 1.2em;
    margin-bottom: .5em;
  }
  .price {
    color: #8cc63f;
    font-weight: bold;
    font-size: 14px;
  }

  .divinationMethod {
    color: #888;
    font-size: 11px;
  }

  .counselorName {
    font-weight: bold;
  }

}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Trial/FirstcomeShowcaseHalfprice.vue